import Flickity from 'flickity';

const initEraGallery = (elements) => {
    const stopScrollingClass = 'stop-scrolling';
    const isActiveClass = 'gallery-open';

    elements.forEach((element) => {
        const toggles = element.querySelectorAll('.js-gallery-toggle');
        const track = element.querySelector('.js-gallery-track');

        let galleryCarousel = null;
        let galleryOpen = false;

        const flickityOptions = {
            cellAlign: 'center',
            wrapAround: true,
            pageDots: false,
            draggable: true,
            prevNextButtons: true,
            setGallerySize: false,
            arrowShape: 'M30.9636 17.3317C32.7801 15.5565 35.7247 15.5556 37.5407 17.3317C39.3566 19.1078 39.3557 21.9879 37.5407 23.7645L15.8791 44.9509L100 44.9509L100 54.0492L15.8791 54.0491L37.5407 75.2355C39.3557 77.0122 39.3566 79.8922 37.5407 81.6683C35.7247 83.4444 32.7801 83.4435 30.9636 81.6683L1.36229 52.7164C-0.454106 50.9398 -0.454105 48.0602 1.36229 46.2836L30.9636 17.3317Z'
        };

        toggles.forEach((toggle) => {
            toggle.addEventListener('click', (event) => {
                event.preventDefault();
                galleryOpen = !galleryOpen;

                if (galleryOpen) {
                    galleryCarousel = new Flickity(track, flickityOptions);
                    element.classList.add('active');
                    document.body.classList.add(stopScrollingClass, isActiveClass);
                } else {
                    element.classList.remove('active');
                    document.body.classList.remove(stopScrollingClass, isActiveClass);
                    galleryCarousel.destroy();
                }
            });
        });

        window.addEventListener('keydown', (event) => {
            if (galleryOpen && event.key === 'Escape') {
                galleryOpen = false;
                element.classList.remove('active');
                document.body.classList.remove(stopScrollingClass, isActiveClass);
                galleryCarousel.destroy();
            }
        });
    });
};

export { initEraGallery as default };
